import React, { useContext, useEffect } from "react";
import { Segment, Tab } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import { RootStoreContext } from "../../../app/stores/rootStore";
import BreadcrumbContainer from "../../../app/common/breadcrumb/BreadcrumbContainer";
import { sectionClient } from "../../../app/util/breadcrumbOptions";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import EditClientForm from "./EditClientForm";
import NewClientForm from "./NewClientForm";
import DashboardUsersClient from "../usersClient/DashboardUsersClient";
import DashboardPackage from "../package/DashboardPackage";
import { PlanTypeEnum } from "../../../app/util/securityEnums";

const DashBoardEditClient: React.FC = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { loadClient, client, reset, getClientById } = rootStore.clienStore;

  const { id } = useParams<{ id: string }>();

  let panes = [];
  useEffect(() => {
    reset();
    if (id !== "null") {
      getClientById(id);
    }
  }, [reset, getClientById, id]);

  if ((id || client.id) !== "null") {
    panes = [
      {
        menuItem: "Datos básicos",
        render: () => (
          <Tab.Pane>
            <EditClientForm id={id} />
          </Tab.Pane>
        ),
      },
      {
        menuItem: "Usuarios",
        render: () => (
          <Tab.Pane>
            <DashboardUsersClient />
          </Tab.Pane>
        ),
      },
    ];
    if (client?.planType === PlanTypeEnum.Package) {
      panes = panes.concat([
        {
          menuItem: "Paquetes",
          render: () => (
            <Tab.Pane>
              <DashboardPackage />
            </Tab.Pane>
          ),
        },
      ]);
    }
  } else {
    panes = [
      {
        menuItem: "Datos básicos",
        render: () => (
          <Tab.Pane>
            <NewClientForm />
          </Tab.Pane>
        ),
      },
    ];
  }

  if (id === "null") document.title = "Mis clientes-Nuevo cliente";
  else document.title = "Editando cliente";

  return (
    <div className="configurationContent">
      <BreadcrumbContainer
        title={
          id === "null"
            ? "Nuevo cliente"
            : "Editando cliente"
        }
        sections={sectionClient}
      />
      <Segment >
        <div className="configurationContent">
          {id !== "null" && !loadClient ? (
            <LoadingComponent content="Cargando informacíon" />
          ) : (
            <Tab panes={panes} />
          )}
        </div>
      </Segment>
    </div>
  );
};

export default observer(DashBoardEditClient);
